import React from "react";
import { Link } from "react-router-dom";

const Support = () => {
  const sections = [
    {
      title: "Getting Started",
      content: (
        <div className="space-y-4 text-gray-600">
          <p>
            Welcome to Daily Dog Support. Here you'll find everything you need
            to make the most of your daily dog training experience. Our app is
            designed to be intuitive and user-friendly, helping you strengthen
            the bond with your dog through daily exercises.
          </p>
          <div className="mt-4">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Quick Start Guide
            </h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>Download Daily Dog from the App Store / Play Store</li>
              <li>
                Open the app and select your preferred language (English or
                German)
              </li>
              <li>Access your first daily exercise immediately</li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      title: "Frequently Asked Questions",
      content: (
        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Exercise Schedule
            </h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium text-gray-900">
                  When do new exercises appear?
                </p>
                <p className="text-gray-600">
                  New exercises are released daily at midnight in your local
                  timezone.
                </p>
              </div>
              <div>
                <p className="font-medium text-gray-900">
                  Can I access previous exercises?
                </p>
                <p className="text-gray-600">
                  Yes, if you save the exercise, it can be accessed at any time.
                </p>
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              App Features
            </h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium text-gray-900">
                  Is internet connection required?
                </p>
                <p className="text-gray-600">
                  Only for downloading new exercises. Once downloaded, exercises
                  can be accessed offline.
                </p>
              </div>
              <div>
                <p className="font-medium text-gray-900">
                  How do I change the language?
                </p>
                <p className="text-gray-600">
                  On the exercise page you can change the language by clicking
                  in the top right corner on EN/DE.
                </p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Troubleshooting",
      content: (
        <div className="space-y-4 text-gray-600">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Common Issues
          </h3>
          <div className="space-y-4">
            <div>
              <p className="font-medium text-gray-900">
                App not loading new exercises?
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Check your internet connection</li>
                <li>Ensure you have the latest app version</li>
                <li>Try closing and reopening the app</li>
              </ul>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Contact Support",
      content: (
        <div className="space-y-4 text-gray-600">
          <p>
            Need additional help? We strive to respond to all inquiries as quick
            as possible.
          </p>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Contact Information
            </h3>
            <ul className="space-y-2">
              <li>
                <span className="font-medium">Email:</span>{" "}
                dailydog.exercises@gmail.com
              </li>
            </ul>
          </div>
          <p className="text-sm">
            For privacy-related inquiries, please visit our{" "}
            <a
              href="/privacy-policy"
              className="text-blue-600 hover:text-blue-800"
            >
              Privacy Policy
            </a>{" "}
            page.
          </p>
        </div>
      ),
    },
  ];

  return (
    <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <div className="logo-container" style={{ filter: "brightness(0.7)" }}>
        <Link to="/">
          <img src="/logo.png" alt="Daily Dog Logo" className="logo" />
        </Link>
        <Link to="/" className="site-title" style={{ textDecoration: "none" }}>
          Daily Dog
        </Link>
      </div>

      <div className="support-page space-y-8">
        <header className="border-b pb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Daily Dog Support
          </h1>
          <p className="text-gray-600">
            Get help with your Daily Dog app and find answers to common
            questions.
          </p>
        </header>

        <main className="space-y-12">
          {sections.map((section, index) => (
            <section key={index}>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {section.title}
              </h2>
              {section.content}
            </section>
          ))}
        </main>
      </div>

      <footer className="site-footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src="/logo.png"
              alt="Daily Dog Logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/40x40?text=DD";
              }}
            />
            <h3 style={{ fontFamily: "Baloo, sans-serif" }}>Daily Dog</h3>
          </div>
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4>Help</h4>
              <ul>
                <li><Link to="/support">Support</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Daily Dog. All rights reserved.</p>
        </div>
      </footer>

    </div>
  );
};

export default Support;
